(function () {
  const sections = document.querySelectorAll('[data-sw-features]');
  if (!sections.length) return;

  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  const initRow = (row) => {
    const wrap = row.querySelector('[data-sw-features-wrap]');
    const track = row.querySelector('[data-sw-features-track]');
    const slides = Array.from(row.querySelectorAll('[data-sw-features-slide]'));
    const prevBtn = row.querySelector('[data-sw-features-prev]');
    const nextBtn = row.querySelector('[data-sw-features-next]');
    const dots = Array.from(row.querySelectorAll('[data-sw-features-dot]'));

    if (!track || slides.length < 2) return null;

    let activeIndex = 0;
    let scrollTimeout;

    const getMaxIndex = () => Math.max(0, slides.length - 1);

    const isAtEnd = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      return track.scrollLeft >= maxScroll - 8;
    };

    const updateScrollHint = () => {
      if (!wrap || !MOBILE_QUERY.matches) {
        wrap?.classList.remove('is-hint-hidden');
        return;
      }

      const hideHint = track.scrollLeft > 12 || isAtEnd() || activeIndex >= getMaxIndex();
      wrap.classList.toggle('is-hint-hidden', hideHint);
    };

    const getSlideOffset = (index) => {
      const slide = slides[index];
      return slide ? slide.offsetLeft : 0;
    };

    const getActiveIndexFromScroll = () => {
      const scrollLeft = track.scrollLeft;
      let index = 0;

      slides.forEach((slide, i) => {
        if (slide.offsetLeft <= scrollLeft + 4) {
          index = i;
        }
      });

      return Math.min(index, getMaxIndex());
    };

    const updateUI = () => {
      if (!MOBILE_QUERY.matches) return;

      const maxIndex = getMaxIndex();
      activeIndex = Math.min(activeIndex, maxIndex);

      dots.forEach((dot) => {
        const pageIndex = parseInt(dot.dataset.swFeaturesDot, 10);
        dot.classList.toggle('is-active', pageIndex === activeIndex);
        dot.setAttribute('aria-selected', pageIndex === activeIndex ? 'true' : 'false');
      });

      if (prevBtn) prevBtn.disabled = activeIndex <= 0;
      if (nextBtn) nextBtn.disabled = activeIndex >= maxIndex;

      updateScrollHint();
    };

    const goTo = (index) => {
      if (!MOBILE_QUERY.matches) return;

      activeIndex = Math.max(0, Math.min(index, getMaxIndex()));
      track.scrollTo({ left: getSlideOffset(activeIndex), behavior: 'smooth' });
      updateUI();
    };

    const resetForDesktop = () => {
      track.scrollTo({ left: 0, behavior: 'auto' });
      activeIndex = 0;
      wrap?.classList.remove('is-hint-hidden');
      updateUI();
    };

    const onPrev = () => goTo(activeIndex - 1);
    const onNext = () => goTo(activeIndex + 1);
    const onScroll = () => {
      if (!MOBILE_QUERY.matches) return;

      updateScrollHint();

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        activeIndex = getActiveIndexFromScroll();
        updateUI();
      }, 80);
    };

    const onDotClick = (event) => {
      const index = parseInt(event.currentTarget.dataset.swFeaturesDot, 10);
      if (!Number.isNaN(index)) goTo(index);
    };

    prevBtn?.addEventListener('click', onPrev);
    nextBtn?.addEventListener('click', onNext);
    track.addEventListener('scroll', onScroll);
    dots.forEach((dot) => dot.addEventListener('click', onDotClick));

    updateUI();
    updateScrollHint();

    return {
      resetForDesktop,
      refresh: () => {
        if (MOBILE_QUERY.matches) {
          updateUI();
          updateScrollHint();
        } else {
          resetForDesktop();
        }
      },
    };
  };

  sections.forEach((section) => {
    const rows = Array.from(section.querySelectorAll('[data-sw-features-row]'));
    const controllers = rows.map((row) => initRow(row)).filter(Boolean);

    const handleBreakpointChange = () => {
      controllers.forEach((controller) => controller.refresh());
    };

    MOBILE_QUERY.addEventListener('change', handleBreakpointChange);
    window.addEventListener('resize', handleBreakpointChange);
  });
})();
